import { useEffect, useState, useRef } from "react";
import { useQuestionizerStore } from "../types/state.ts";

export default function PreviewView() {
  //const [active_tab, set_active_tab] = useState<number>(null);
  const [active_tab, set_active_tab] = useState<number | null>(null);
  const activeFpId = useQuestionizerStore((state) => state.activeFpId);

   const result = useQuestionizerStore((state) => state.result);
   const entry = result?.find((r) => r.fp_id === String(activeFpId));
  
  const gegenstandRef = useRef<HTMLDivElement>(null);
  
  const preview_text_blocks = useQuestionizerStore(
    (state) => state.preview_text_blocks
  );
  const setActiveFpId = useQuestionizerStore(
    (state) => state.setActiveFpId
  );

	useEffect(() => {
	  if (gegenstandRef.current) {
		gegenstandRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
		gegenstandRef.current.focus({ preventScroll: true });
	  }
	}, []);

useEffect(() => {
  if (
    active_tab === null &&
    preview_text_blocks &&
    preview_text_blocks.length > 0
  ) {
    set_active_tab(0); // automatisch "Gegenstand"
  }
}, [preview_text_blocks, active_tab]);

  /*useEffect(() => {
    if (!preview_text_blocks || preview_text_blocks.length === 0) return;
    set_active_tab(preview_text_blocks[0].id);
  }, [preview_text_blocks]);*/

  if (!preview_text_blocks || preview_text_blocks.length === 0) return <></>;

  const blocks = [
    { id: 0, title: "Gegenstand", blocks: [2] },
    { id: 1, title: "Art & Höhe", blocks: [6, 112] },
    { id: 2, title: "Berechtigte", blocks: [1] },
    { id: 3, title: "Antragsstellung & weitere Infos", blocks: [3, 113, 10, 111] },
  ];

  return (
    <div className="flex flex-col">
	  {entry && (
		  <div className="mb-4">
			<h1>{entry.region}</h1>
			<h2>{entry.fp_name}</h2>
			<p>{entry.fp_betrag}</p>
		  </div>
		)}
		<div className="flex flex-row flex-wrap mb-4">
        {blocks.map((block) => (
          <div
            key={block.id}
            className={
              "cursor-pointer flex flex-row text-center justify-center flex-grow p-4 mr-[2px] " +
              (block.id === active_tab
                ? "bg-[var(--buttons-bg)] text-white"
                : "bg-[var(--neutral-light)] text-black")
            }
            tabIndex={0}
            onKeyUp={(event) => {
              if (event.code !== " " && event.code !== "Enter") return;
              set_active_tab(block.id);
            }}
            onClick={() => set_active_tab(block.id)}
          >
            {block.title}
          </div>
        ))}
      </div>

      <div className="p-4">
        {blocks
          .filter((block) => block.id === active_tab)
          .map((block) => (
            <div className="flex flex-col" key={block.id} ref={block.id === 0 ? gegenstandRef : null} tabIndex={block.id === 0 ? -1 : undefined} >
              {block.blocks.map((block_id) => {
                const text = preview_text_blocks.find((b) => b.id == block_id.toString());
                if (!text) return null;
                return (
                  <div key={block_id}>
                    <b>{text.name}</b>
                    <div dangerouslySetInnerHTML={{ __html: text.content }} />
                    <br />
                  </div>
                );
              })}
            </div>
          ))}
      </div>
    </div>
  );
}